<template>
  <div class="row">
    <div class="col-12 row text-left pb-1">
      <router-link to="/portal/enterprise/overview" class="btn btn-sm">
        <button class="btn btn-warning">Overview</button>
      </router-link>

      <router-link to="/portal/enterprise/users" class="btn btn-sm">
        <button class="btn btn-warning">Site Statistic</button>
      </router-link>

      <router-link to="/portal/enterprise/users" class="btn btn-sm">
        <button class="btn btn-warning">User Management</button>
      </router-link>

      <router-link to="/portal/enterprise/report" class="btn btn-sm">
        <button class="btn btn-warning">Report</button>
      </router-link>

      <router-link to="/portal/enterprise/voicemail" class="btn btn-sm">
        <button class="btn btn-warning">Voice Mail</button>
      </router-link>

      <router-link to="/portal/enterprise/hotbilling" class="btn btn-sm">
        <button class="btn btn-warning">Hot Billing</button>
      </router-link>

      <router-link to="/portal/enterprise/prepaid" class="btn btn-sm">
        <button class="btn btn-warning">Prepaid</button>
      </router-link>

      <router-link to="/portal/enterprise/prepaid" class="btn btn-sm">
        <button class="btn btn-warning">Site Setting</button>
      </router-link>
    </div>


  </div>
</template>

<script>
export default {
  name: "enterprise-menu",
  mouted() {
    console.log("User Menu");
    console.log(route.meta);
  },
  methods: {
    getBreadName(route) {
      return route.name;
    },
  },
};
</script>

<style scoped></style>
